
// NATIVE 

// INSTALLED 
import { setEpsRedux } from './mainSlice';
import { activeAreaService } from '../../services/area.service';
import { checkingPreload, unCheckingPreload } from '../loading';
import { getMainService } from '../../services/main.service';
import { setEmployeesCumpleanosRedux, setEmployeesTareasPendientesRedux, setEmployeLateResumenRedux, setEmployePeriodoPruebaResumenRedux, setEmployeResumenRedux } from '../employee';


// CUSTOM 


export const getMainData = (): any => {
  

  return async( dispatch: any ) => { 


    await dispatch( checkingPreload() );
           
     const response = await  getMainService();

     

      if ( response.ok ) {

        const { data } = response;

        const { resumenEmployees, resumenEmployeesLate, resumenEmpleadosCumpleanos,
             resumenEmployeesPeriodoPrueba, resumenEmployeesTareasPendientes } = data;

          await dispatch( setEmployeResumenRedux( resumenEmployees ) );
          await dispatch( setEmployeLateResumenRedux( resumenEmployeesLate ) );
          await dispatch( setEmployePeriodoPruebaResumenRedux( resumenEmployeesPeriodoPrueba ) );
          await dispatch( setEmployeesTareasPendientesRedux( resumenEmployeesTareasPendientes ) );
          await dispatch( setEmployeesCumpleanosRedux( resumenEmpleadosCumpleanos ) );

      }  


      await dispatch( unCheckingPreload() );
      
      return response;

    

  }

    
}